export const SORT_ASCENDING = "asc";
export const SORT_DESCENDING = "desc";
export const SORT_UNSORTED = "none";
export const SORT_DIRECTIONS = [SORT_UNSORTED, SORT_ASCENDING, SORT_DESCENDING];
export const ASCENDING = "ascending";
export const DESCENDING = "descending";
export const SORT_OTHER = "other";
export const ANNOUNCEMENT_DELAY = 250;